import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {ICreateCustomerV2Payload, ICreateCustomerV2Response} from "../interfaces/ICustomerV2";

const BASE_API = process.env.REACT_APP_BASE_API_V2;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;

export const customerV2Slice = createApi({
  reducerPath: 'customerV2',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState }) => {
      if (KRANKQUE_SECRET_KEY) {
        headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      }

      if (KRANKQUE_APPLICATION_ID) {
        headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      }

      return headers;
    }
  }),
  tagTypes: ['CustomerV2'],
  endpoints: (builder) => ({
    createCustomerV2: builder.mutation<ICreateCustomerV2Response, ICreateCustomerV2Payload>({
      query: (req) => ({
        url: '/customer',
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
        method: 'POST',
        body: req.body
      })
    }),
  }),
});

export const { useCreateCustomerV2Mutation } = customerV2Slice;

